"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TYPE2__ITEM_SELECT_ERROR_TEXT = exports.TYPE2_SELECTION_ERROR = exports.TYPE2_MIN_SELECT_ITEM = exports.TYPE2_MAX_SELECT_ITEM = exports.TYPE2_ITEM_SELECT_TEXT = exports.TYPE1_SELECTION_ERROR = exports.TYPE1_MIN_SELECT_ITEM = exports.TYPE1_MAX_SELECT_ITEM = exports.MAX_ITEM_SELECTED = exports.GROUP_SELECTION_TXTAREA_PLACEHOLDER = exports.GROUP_SELECTION_TXTAREA_LABEL = exports.GROUP_SELECTION_MIN_SELECT_ITEM = exports.GROUP_SELECTION_MAX_SELECT_ITEM = exports.GROUP_SELECTION_ERROR = exports.BACK_SELECTION_ERROR = exports.BACK_MIN_SELECT_ITEM = exports.BACK_MAX_SELECT_ITEM = void 0; // ItemDetails Type1 Layout Component

var TYPE1_MIN_SELECT_ITEM = 'You must select at least {option}';
exports.TYPE1_MIN_SELECT_ITEM = TYPE1_MIN_SELECT_ITEM;
var TYPE1_MAX_SELECT_ITEM = 'You cannot select more than {option}';
exports.TYPE1_MAX_SELECT_ITEM = TYPE1_MAX_SELECT_ITEM;
var TYPE1_SELECTION_ERROR = 'Oops! Please check your selections!'; // ItemDetails Type2 Layout Component

exports.TYPE1_SELECTION_ERROR = TYPE1_SELECTION_ERROR;
var TYPE2_ITEM_SELECT_TEXT = 'Select One';
exports.TYPE2_ITEM_SELECT_TEXT = TYPE2_ITEM_SELECT_TEXT;
var TYPE2__ITEM_SELECT_ERROR_TEXT = 'You must select an item';
exports.TYPE2__ITEM_SELECT_ERROR_TEXT = TYPE2__ITEM_SELECT_ERROR_TEXT;
var TYPE2_MIN_SELECT_ITEM = 'You must select at least {option}';
exports.TYPE2_MIN_SELECT_ITEM = TYPE2_MIN_SELECT_ITEM;
var TYPE2_MAX_SELECT_ITEM = 'You cannot select more than {option}';
exports.TYPE2_MAX_SELECT_ITEM = TYPE2_MAX_SELECT_ITEM;
var TYPE2_SELECTION_ERROR = 'Oops! Please check your selections!'; // ITEM_DETAILS_back Component

exports.TYPE2_SELECTION_ERROR = TYPE2_SELECTION_ERROR;
var BACK_SELECTION_ERROR = 'Oops! Please check your selections!';
exports.BACK_SELECTION_ERROR = BACK_SELECTION_ERROR;
var BACK_MIN_SELECT_ITEM = 'You must select at least {option}';
exports.BACK_MIN_SELECT_ITEM = BACK_MIN_SELECT_ITEM;
var BACK_MAX_SELECT_ITEM = 'You cannot select more than {option}';
exports.BACK_MAX_SELECT_ITEM = BACK_MAX_SELECT_ITEM;
var MAX_ITEM_SELECTED = 'Maximum modifications for {option} selected'; // ItemDetails Component

exports.MAX_ITEM_SELECTED = MAX_ITEM_SELECTED;
var GROUP_SELECTION_ERROR = 'Oops! Please check your selections!';
exports.GROUP_SELECTION_ERROR = GROUP_SELECTION_ERROR;
var GROUP_SELECTION_MIN_SELECT_ITEM = 'You must select at least {groupMin}';
exports.GROUP_SELECTION_MIN_SELECT_ITEM = GROUP_SELECTION_MIN_SELECT_ITEM;
var GROUP_SELECTION_MAX_SELECT_ITEM = 'You cannot select more than {groupMax}';
exports.GROUP_SELECTION_MAX_SELECT_ITEM = GROUP_SELECTION_MAX_SELECT_ITEM;
var GROUP_SELECTION_TXTAREA_LABEL = 'Notes';
exports.GROUP_SELECTION_TXTAREA_LABEL = GROUP_SELECTION_TXTAREA_LABEL;
var GROUP_SELECTION_TXTAREA_PLACEHOLDER = 'Add additional information about to this item';
exports.GROUP_SELECTION_TXTAREA_PLACEHOLDER = GROUP_SELECTION_TXTAREA_PLACEHOLDER;
var _default = {
  TYPE2_ITEM_SELECT_TEXT: TYPE2_ITEM_SELECT_TEXT,
  TYPE2__ITEM_SELECT_ERROR_TEXT: TYPE2__ITEM_SELECT_ERROR_TEXT,
  TYPE1_MIN_SELECT_ITEM: TYPE1_MIN_SELECT_ITEM,
  TYPE1_MAX_SELECT_ITEM: TYPE1_MAX_SELECT_ITEM,
  TYPE1_SELECTION_ERROR: TYPE1_SELECTION_ERROR,
  TYPE2_MIN_SELECT_ITEM: TYPE2_MIN_SELECT_ITEM,
  TYPE2_MAX_SELECT_ITEM: TYPE2_MAX_SELECT_ITEM,
  TYPE2_SELECTION_ERROR: TYPE2_SELECTION_ERROR,
  BACK_SELECTION_ERROR: BACK_SELECTION_ERROR,
  BACK_MIN_SELECT_ITEM: BACK_MIN_SELECT_ITEM,
  BACK_MAX_SELECT_ITEM: BACK_MAX_SELECT_ITEM,
  GROUP_SELECTION_ERROR: GROUP_SELECTION_ERROR,
  GROUP_SELECTION_MIN_SELECT_ITEM: GROUP_SELECTION_MIN_SELECT_ITEM,
  GROUP_SELECTION_MAX_SELECT_ITEM: GROUP_SELECTION_MAX_SELECT_ITEM,
  GROUP_SELECTION_TXTAREA_LABEL: GROUP_SELECTION_TXTAREA_LABEL,
  GROUP_SELECTION_TXTAREA_PLACEHOLDER: GROUP_SELECTION_TXTAREA_PLACEHOLDER
};
exports["default"] = _default;